export default __webpack_public_path__ + "f98b19c789fb92b886ba3372897446ed.ttf";